import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { hasValue, asString } from '../Utils/ValueUtils';
import { formatterParamParamFind2 } from '../Utils/ParamUtils';

class TEDTranslateValuesDisplayer extends BaseDisplayer {
  public static getInstance(): TEDTranslateValuesDisplayer {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDTranslateValuesDisplayer;

  defaultParams(): string {
    return 'TranslateValues=""';
  }

  display(value: ValueType, displayText: boolean = true, params: string = '') {
    const TRANSLATE_NULL = '[BLANK]';
    let result = '';
    const findParam = asString(value);
    if (hasValue(value) && findParam) {
      const param = formatterParamParamFind2(
        'TranslateValues',
        findParam,
        params,
        this.defaultParams()
      );

      if (param) {
        const { paramName, paramValue } = param;
        const trimmedValue = paramValue.trim();
        if (paramValue.trim() !== TRANSLATE_NULL) {
          result = trimmedValue !== '' ? trimmedValue : paramName.trim();
        } else {
          result = asString(value) || '';
        }
      } else {
        result = asString(value) || '';
      }
    } else {
      const param = formatterParamParamFind2(
        'TranslateValues',
        TRANSLATE_NULL,
        params,
        this.defaultParams()
      );
      if (param) {
        result = param.paramValue.trim();
      }
    }

    return result;
  }
}

export { TEDTranslateValuesDisplayer };
